import _ from 'lodash'

import Controller from 'lib/controller'
import dispatcher from 'service/event_dispatcher'
import dataProvider from 'service/data_provider'
import CarouselView from 'view/carousel'
import CollapsibleTextView from 'view/collapsible_text'
import ConnectButtonView from 'component/connect_button/connect_button'
import EventDetailsButtonStackView from 'bundle/event_promotion/view/button_stack'
import NameTagsView from 'bundle/event_promotion/view/name_tags'
import Router from 'service/router'
import SyncView from 'view/sync_view'
import WirePostModel from 'component/wire/model'
import WirePostView from 'component/wire/wire'
import analytics from 'service/google_analytics'
import ModalView from 'component/modal/modal'
import PostPhotosView from 'bundle/event_promotion/view/post_photos'
import windowView from 'shared/view/window'

const ATTENDANCE_ACCEPT_SUCCESS_EVENT = 'Attendance:accept:success'

const Ctrl = Controller.extend({
    events: {
        'click .js-attendance-toggle': '_handleAttendButtonClick',
    },

    initialize() {
        _.bindAll(this, _.functionsIn(this))

        this.eventPromotion = dataProvider.get('eventPromotion')

        this.isMobile = windowView.isMobile()
        this.isPastEvent = this.eventPromotion.isPast

        this.bootstrapElements()
        this.subscribe()

        this._initializeCollapsibleText()
        this._initializeWirePost()
    },

    bootstrapElements() {
        this.$connectButton = this.$('.js-connect-button')
        this.$eventButtonStack = this.$('.js-event-button-stack')
        this.$eventTeaserContainer = this.$('.js-infoblock-teaser-container')
        this.$mobileCarousel = this.$('.js-mobile-carousel-wrapper')
        this.$wireContainer = this.$('.js-wire-container')

        this.$connectButton.each((index, element) => {
            this.initSubview(ConnectButtonView, { el: element })
        })

        if (this.$eventTeaserContainer.length) {
            this.infoBlockTeaserView = this.initSubview(SyncView, {
                el: this.$eventTeaserContainer,
            })
        }

        if (this.$eventButtonStack.length) {
            this.buttonStackView = this.initSubview(EventDetailsButtonStackView, {
                el: this.$eventButtonStack,
                entityId: this.eventPromotion.eventId,
                entityType: 'event',
            })
        }

        this.guestlistTeaserView = this.initSubview(SyncView, {
            el: this.$('.js-guestlist-teaser-container'),
        })

        // Initialize slick.js carousel only for post-event photos below tablet breakpoint
        if (this.isPastEvent && this.isMobile && this.$mobileCarousel.length) {
            this.initSubview(CarouselView, {
                el: this.$mobileCarousel,
            })
        }

        this.$('.js-post-photos').each((index, element) => {
            this.initSubview(PostPhotosView, {
                el: element,
                gallery: dataProvider.get('gallery'),
            })
        })
    },

    subscribe() {
        // When a modal is shown,
        // 1. initialize photo upload if it's the photo upload modal
        // 2. bind attendance handler if any is found
        dispatcher.on('redraw', (content) => {
            const $attendanceAcceptTriggers = this.$('.js-attendance-accept', content.data)

            if ($attendanceAcceptTriggers.length) {
                $attendanceAcceptTriggers.on('click', this.buttonStackView.handleAttendanceUpdate)
            }
        })

        if (this.buttonStackView) {
            this.buttonStackView.on('attendance:update', () => {
                if (this.guestlistTeaserView) {
                    this.guestlistTeaserView.update()
                }

                if (this.infoBlockTeaserView) {
                    this.infoBlockTeaserView.update()
                }
            })
        }

        if (this.guestlistTeaserView) {
            this.guestlistTeaserView.model.on('sync', () => {
                dispatcher.dispatch('redraw', this.guestlistTeaserView.el)
            })
        }

        dispatcher.on('printNameTags:init', this._initializeNameTags)
    },

    _initializeCollapsibleText() {
        const collapsibleTextOptions = {
            el: '.js-collapse-event-description',
            collapseHeight: '115',
            collapseSpeed: '200',
        }

        if (this.isPastEvent) {
            Object.assign(collapsibleTextOptions, {
                el: '.js-collapse-post-event-description',
            })
        }

        this.initSubview(CollapsibleTextView, collapsibleTextOptions)
    },

    _initializeNameTags(event, el) {
        this.initSubview(NameTagsView, { el })
    },

    /**
     * Notice:
     * On event promotion page wire is used only for comments.
     * Instead of wire view there are comments view as root element
     */
    _initializeWirePost() {
        if (!this.$wireContainer.length) {
            return
        }

        const wirePostModel = new WirePostModel({
            url: Router.path('event_promotion_wire_index', {
                eventId: this.eventPromotion.eventId,
            }),
        })

        if (this.eventPromotion.canSeeComments) {
            this.initSubview(WirePostView, {
                el: this.$wireContainer,
                model: wirePostModel,
            })
        }

        wirePostModel.fetch()
    },

    // To make the ajaxFormView work with the pre-existing comments API
    _parseStatusUpdateResponse(rawResponse) {
        return Object.assign({}, rawResponse, {
            formHtml: rawResponse.content.form,
            entry: rawResponse.content.comment,
        })
    },

    _handleAttendButtonClick() {
        analytics.trackEvent('event_attend', 'button')
        dispatcher.dispatch(ATTENDANCE_ACCEPT_SUCCESS_EVENT)
    },
})

export default new Ctrl()
